import {
  AvatarEmotion,
  AvatarGesture,
  ChallengeMode,
  MutationEducationSessionPassAdaptiveInputArgs,
} from "../../../schema";
import {isChoiceUserInputAction, isUserInputAction} from "../../../types";
import {passAdaptiveInputMutation, PassAdaptiveInputMutationData} from "../graphql";
import {getCurrentAction} from "../selectors";
import getSessionId from "../selectors/getSessionId";
import {PlayableAdaptiveResponse, PlayerReduxDispatch, PlayerReduxState} from "../types";

export default function updateAdaptiveInputState(lastPlayedResponseIndex: number) {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();
    const action = getCurrentAction(state);

    if (!action || !(isUserInputAction(action) || isChoiceUserInputAction(action))) {
      console.warn("updateAdaptiveInputState: wrong action");
      return;
    }

    if (!state.adaptiveInput) {
      console.warn("updateAdaptiveInputState: wrong adaptiveInput");
      return;
    }

    const finishedResponse = state.adaptiveInput.responses.find((r) => r.index === lastPlayedResponseIndex);
    if (
      state.challenge.mode === ChallengeMode.RPG_MODE &&
      finishedResponse?.text &&
      (isUserInputAction(action) || isChoiceUserInputAction(action))
    ) {
      dispatch({
        type: "appendDialogueHistory",
        payload: {
          action: {
            __typename: "AvatarAction",
            id: `${action.id}-rpg-adaptive-${finishedResponse.id}`,
            text: finishedResponse.text,
            emotion: AvatarEmotion.IDLE,
            gesture: AvatarGesture.NARRATIVE,
            isCustomAudio: !!finishedResponse.audioUrl,
            audio: finishedResponse.audioUrl ?? undefined,
          },
        },
      });
    }

    const newResponses = state.adaptiveInput.responses.map<PlayableAdaptiveResponse>((response) =>
      response.index === lastPlayedResponseIndex ? {...response, played: true} : response,
    );

    dispatch({
      type: "update",
      payload: {
        adaptiveInput: {
          ...state.adaptiveInput,
          responses: newResponses,
        },
      },
    });

    const allPlayed = newResponses.reduce((allPlayed, {played}) => allPlayed && played, true);
    if (allPlayed) {
      if (state.challenge.mode === ChallengeMode.RPG_MODE) {
        const sessionId = getSessionId(state);
        const adaptiveUuid = state.adaptiveInput.uuid;
        if (!sessionId || !adaptiveUuid) {
          console.warn("updateAdaptiveInputState: RPG pass adaptive input missing session or uuid");
          dispatch({
            type: "update",
            payload: {isRecognizing: false, adaptiveInput: null},
          });
          return;
        }

        state.client
          .mutate<PassAdaptiveInputMutationData, MutationEducationSessionPassAdaptiveInputArgs>({
            mutation: passAdaptiveInputMutation,
            variables: {
              sessionId,
              actionId: action.id,
              adaptiveInputUuid: adaptiveUuid,
              recognizedText: state.lastUserInputResult?.recognizedText,
              audioUuid: state.lastUserInputResult?.audioUuid
            },
          })
          .then((mutationResult) => {
            const goNext = mutationResult.data?.result === true;
            const currentState = getState();
            dispatch({
              type: "update",
              payload: {
                isRecognizing: false,
                ...(goNext ? {} : {rpgTurnKey: currentState.rpgTurnKey + 1}),
              },
            });
            if (goNext) {
              dispatch({type: "next"});
            }
          })
          .catch((err) => {
            console.error(err);
            dispatch({
              type: "update",
              payload: {isRecognizing: false, adaptiveInput: null},
            });
          });
        return;
      }

      dispatch({
        type: "update",
        payload: {
          isRecognizing: false,
        },
      });
      dispatch({
        type: "next",
      });
    } else {
      dispatch({
        type: "playAdaptiveResponse",
      });
    }
  };
}
